import API from 'shared/lib/api'

export default {

  // Fetches resources from the API.
  // On success it removes previous values from the collection and sets the new ones.
  // Logic for this is in `reduxModel.js` `getReducer()` function.
  //
  // @example
  //   SomeModel.actions.refresh({ page: 2 });
  //
  actionMethod: (model, options = {}) => {
    options.apiVersion = options.apiVersion ?? model.options.apiVersion

    if (!options.stats) {
      options.stats = { total: 'count' }
    } else {
      options.stats.total = 'count'
    }

    return API.getCollection(model.pluralName, options)
  },

  // Updates flags on collection.
  //
  reduceMethod: (model, collection, action) => {
    switch (action.type) {
      case model.actionTypes.FETCH_ALL_START:
        return collection.set('isLoadingCollection', true)

      case model.actionTypes.FETCH_ALL_ERROR:
        return collection.set('isLoadingCollection', false)

      case model.actionTypes.FETCH_ALL_SUCCESS:
        return collection.set('isLoadingCollection', false)
    }
  }
}
